import React from "react"
import { KpiCard } from "../ExtendedAnalytics/ReviewsView"
import { day } from "./catalogView"

// The analytics view of the tournament feedback (sportya-api docs/tournament-feedback.md, „Analytics: view-ul
// tournament-feedback”), read by the Analysis tab and by the Dashboard's „Tournament feedback” group.
export const FEEDBACK_VIEW = "tournament-feedback"
export const DASHBOARD_FEEDBACK_QUERY = { view: FEEDBACK_VIEW, period: "last-30-days", comparison: "previous-adjacent", sport: "all", locationScope: "global" }

// The view's theme cards: the server marks them with their group.
export const feedbackKpis = snapshot => (snapshot?.kpis || []).filter(metric => metric.group === FEEDBACK_VIEW)

// One card per rated theme, as the review cards (no stars): a theme deactivated in the period and one added in it say so.
export function FeedbackCards({ kpis, compact = false }) {
  return <div className="row">
    {kpis.map(metric => <KpiCard metric={metric} compact={compact} key={metric.key}>
      {day(metric.catalog?.deactivatedAt) && <p className="text-muted small mb-0 mt-1">Deactivated on {day(metric.catalog.deactivatedAt)}. Answers until then.</p>}
      {day(metric.catalog?.askedSince) && <p className="text-muted small mb-0 mt-1">Asked since {day(metric.catalog.askedSince)}.</p>}
    </KpiCard>)}
  </div>
}
